@if (offersEligible) {
  <section appBannerObserver (bannerVisible)="onBannerDisplayed()" class="paddingTopBottom">
    <section class="row">
      <div class="col-md-12 acc-ovrvw-ntfcntns-bnr text-center">
        <h3 class="notification-hdng">
          {{ "accountOverview.offerEligibility.bottonBannerTitle" | cxTranslate }}
        </h3>
        @if (!offerAccepted) {
          <div>
            <span class="accOvrvw-ntfctn-msg" style="text-align:center">
              <p><img src="/icons/confirmation-positive-green.png" alt="">
              {{ "accountOverview.offerEligibility.topBannerInfo" | cxTranslate }}</p>
              <p>{{ "accountOverview.offerEligibility.topBannerInfo2" | cxTranslate }}</p>
            </span>
            <button type="button" class="btn-secondary" (click)="onViewOffer()">
            {{ "accountOverview.offerEligibility.topBannerButton" | cxTranslate }}</button>
          </div>
        }
        @if (offerAccepted) {
          <div>
            <span class="accOvrvw-ntfctn-msg" style="text-align:center">
              <p><img src="/icons/confirmation-positive-green.png" alt="">
              {{ "accountOverview.offerEligibility.bottomBannerAcceptedInfo" | cxTranslate }}</p>
              <p>{{ "accountOverview.offerEligibility.bottomBannerAcceptedInfo2" | cxTranslate }}</p>
            </span>
            <button type="button" class="btn-secondary" [routerLink]="['/offers']">
            {{ "accountOverview.offerEligibility.bottomBnnerButton" | cxTranslate }}</button>
          </div>
        }
      </div>
    </section>
  </section>
}
